// src/features/tickets/hooks/useTicketKundenKontext.ts
//
// Rein lesender Hook: laedt den Kontext fuer die manuelle Kundenzuordnung
// eines Tickets (Absender, waehlbare Regeln, Firmengruppe des Tickets und
// Vorschlaege) ueber ticketService.getCustomerAssignmentContext.
//
// Wird neu geladen, wenn sich Ticket, Kunde oder Firmengruppe des Tickets
// aendern (z. B. nach einer Zuordnung oder durch die Live-Aktualisierung).
// Versorgt das Zuordnungsfenster und die Vorschlaege in der Seitenleiste.

import { useState, useEffect, useCallback } from 'react';
import { ticketService } from '../services/TicketService';
import { TicketKundenKontext } from '../types';

export interface UseTicketKundenKontextResult {
  loading: boolean;
  kontext: TicketKundenKontext | null;
  reload: () => Promise<void>;
}

export const useTicketKundenKontext = (
  ticketId: string | undefined,
  customerId: string | null,
  customerGroupId: string | null
): UseTicketKundenKontextResult => {
  const [loading, setLoading] = useState(false);
  const [kontext, setKontext] = useState<TicketKundenKontext | null>(null);

  const reload = useCallback(async () => {
    if (!ticketId) {
      setKontext(null);
      return;
    }
    setLoading(true);
    try {
      const data = await ticketService.getCustomerAssignmentContext(ticketId);
      setKontext(data);
    } finally {
      setLoading(false);
    }
  }, [ticketId]);

  useEffect(() => {
    let cancelled = false;
    if (!ticketId) {
      setKontext(null);
      return;
    }
    setLoading(true);
    ticketService.getCustomerAssignmentContext(ticketId)
      .then(data => { if (!cancelled) setKontext(data); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => {
      cancelled = true;
    };
  }, [ticketId, customerId, customerGroupId]);

  return { loading, kontext, reload };
};
